const PENDING_PROFILE_ONBOARDING_KEY = "tra_pending_profile_onboarding";

export function readPendingProfileOnboarding() {
  try {
    return sessionStorage.getItem(PENDING_PROFILE_ONBOARDING_KEY) === "1";
  } catch {
    return false;
  }
}

export function writePendingProfileOnboarding(pending) {
  try {
    if (pending) sessionStorage.setItem(PENDING_PROFILE_ONBOARDING_KEY, "1");
    else sessionStorage.removeItem(PENDING_PROFILE_ONBOARDING_KEY);
  } catch {
    /* private mode */
  }
}
